import type { BoardStation } from './board-types'

const formatCssNumber = (value: number) => {
    return Number(value.toFixed(4)).toString()
}

export const TV_BOARD_FRAME = {
    banner: {
        height: 616,
        width: 1811,
        x: 1969,
        y: 144,
    },
    height: 2160,
    masterCard: {
        background: '#ffffff',
        gradient: {
            from: '#ffffff',
            height: 1085,
            to: '#71a4af',
            width: 1085,
            x: -293,
            y: -460,
        },
    },
    masters: {
        cardHeight: 2020,
        cardWidth: 444,
        count: 4,
        gap: 24,
        height: 2020,
        width: 1848,
        x: 60,
        y: 70,
    },
    queueTile: {
        shadow: {
            blur: 28.42,
            color: 'rgba(24,24,27,0.1)',
            y: 16.24,
        },
    },
    width: 3840,
} as const

export const tv = (value: number) => {
    const vw = formatCssNumber((value / TV_BOARD_FRAME.width) * 100)
    const dvh = formatCssNumber((value / TV_BOARD_FRAME.height) * 100)

    return `min(${vw}vw, ${dvh}dvh)`
}

const tvOffset = (value: number) => {
    if (value < 0) {
        return `calc(-1 * ${tv(Math.abs(value))})`
    }

    return tv(value)
}

export const getBoardMasterCardBackground = () => {
    const { background, gradient } = TV_BOARD_FRAME.masterCard

    return `linear-gradient(180deg, ${gradient.from} 0%, ${gradient.to} 100%) ${tvOffset(
        gradient.x
    )} ${tvOffset(gradient.y)} / ${tv(gradient.width)} ${tv(gradient.height)} no-repeat, ${background}`
}

export const getBoardDropShadow = ({
    blur,
    color,
    y,
}: {
    blur: number
    color: string
    y: number
}) => {
    return `0 ${tv(y)} ${tv(blur)} ${color}`
}

export const getVisibleBoardStations = (stations: BoardStation[]) => {
    return stations.slice(0, TV_BOARD_FRAME.masters.count)
}
